import { api } from "./client";

export type SendInput = {
  to: string[];
  cc?: string[];
  subject: string;
  body: string;
  threadId?: string;
  inReplyToGmailMessageId?: string;
};

export function sendMessage(input: SendInput): Promise<{ ok: true; gmailMessageId: string; gmailThreadId: string }> {
  return api(`/messages`, { method: "POST", body: input });
}

export function markRead(messageId: string): Promise<{ updated: number }> {
  return api(`/messages/${messageId}/mark-read`, { method: "POST" });
}
